import React, { PropsWithChildren } from "react";
import { useScrollLock } from "usehooks-ts";
import { Portal } from "component-library";
import { CrossThickIcon } from "assets";
import ProfileButton from "pages/Profile/components/common/ProfileButton";

interface Props {
  onToggle?: () => void;
}

const FullScreenMediaViewer = ({
  onToggle,
  children,
}: PropsWithChildren<Props>) => {
  useScrollLock({});

  return (
    <Portal>
      <div className="fixed left-0 top-0 z-50 h-full w-full overflow-auto bg-black/90">
        <ProfileButton
          className="absolute right-4 top-4 rounded-full text-white"
          onClick={onToggle}
        >
          <CrossThickIcon />
        </ProfileButton>
        {children}
      </div>
    </Portal>
  );
};

export default FullScreenMediaViewer;
